// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__alOSH","tab":"ProcedureTabs_tab__1m_94"};